export default __webpack_public_path__ + "ce20865bc27cca38fa395d310fc0122b.svg";